<template>
  <div class="block text-center" style="height: 540px; width: 100%">
    <el-carousel height="auto" autoplay>
      <el-carousel-item style="height: 522px">
        <img src="@/assets/2.jpg" alt="" class="banner-image" />
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="container">
    <div>
      <h1>赛事介绍</h1>
      <span>INTRODUCE</span>
      <div class="line"></div>
    </div>
    <el-row>
      <el-col :span="9"
        ><div class="grid-content ep-bg-purple" />
        <img style="height: 309px" src="@/assets/16.jpg" alt="Element logo" />
      </el-col>
      <el-col
        :span="15"
        style="
          padding: 20px 30px 0 30px;
          text-align: left;
          background: #0f0f0f;
          line-height: 25px;
          height: 309px;
        "
        ><div class="grid-content ep-bg-purple-light" />

        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
        </p>
        <el-button
          type="danger"
          size="large"
          style="padding: 12px 55px; background: #ce0203; border: #ce0203"
          >查看详情 »</el-button
        >
      </el-col>
    </el-row>
  </div>

  <div class="container">
    <div>
      <h1>赛事信息</h1>
      <span>INFORMATION</span>
      <div class="line"></div>
    </div>
  </div>
  <div
    style="background: #0f0f0f; margin-top: 20px"
    v-for="(item, index) in 2"
    key="index"
  >
    <el-row
      style="
        text-align: left;
        background: #0f0f0f;
        line-height: 25px;
        height: 400px;
        display: flex;
        align-items: center;
        width: 1200px;
        margin: 0 auto;
      "
    >
      <el-col :span="5"
        ><div class="grid-content ep-bg-purple" />
        <img style="width: 300px" src="@/assets/奖杯.png" alt="Element logo" />
      </el-col>
      <el-col
        :span="17"
        style="
          text-align: left;
          line-height: 25px;
          color: #fff;
          font-size: 14px;
          margin-left: 80px;
          width: 100%;
        "
      >
        <div style="display: flex; align-items: center">
          <div style="font-size: 22px">自由挑战赛(实盘)</div>
          <span
            style="
              padding: 0 10px;
              border: 1px solid #d10005;
              color: #d10005;
              font-size: 10px;
              line-height: 16px;
              margin-left: 12px;
            "
          >
            进行中
          </span>
        </div>
        <div
          style="
            border-bottom: 1px #4f4f4f solid;
            width: 100%;
            height: 1px;
            margin: 10px 0;
          "
        ></div>
        <p>
          比赛简介:自由实盘挑战赛由冠融科技主办，多家经纪商协办，比赛目的是通过实盘挑战赛方式为操盘手提供展示技术实力和学习
        </p>
        <p>
          周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
        </p>
        <p>
          周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
        </p>
        <div
          style="
            float: right;
            display: flex;
            align-items: center;
            margin-top: 30px;
          "
        >
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <span style="font-size: 40px">633</span>
            <div>报名人数</div>
          </div>
          <el-button
            type="danger"
            size="large"
            style="
              background: #ce0203;
              border: #ce0203;
              --el-button-size: 23px;
              font-size: 12px;
              margin-left: 10px;
            "
            >立即报名 »</el-button
          >
        </div>
      </el-col>
    </el-row>
  </div>

  <div class="container">
    <div>
      <h1>赛事排行榜</h1>
      <span>RANKING LIST</span>
      <div class="line"></div>
    </div>

    <!-- {
    排名: "2016-05-03",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  }, -->
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="排名" label="排名" />
      <el-table-column prop="昵称" label="昵称" />
      <el-table-column prop="MT4账号" label="MT4账号" />
      <el-table-column prop="当前净值" label="当前净值" />
      <el-table-column prop="昵称" label="昵称" />
      <el-table-column prop="利润率" label="利润率" />
      <el-table-column prop="回撤率" label="回撤率" />
      <el-table-column prop="收益率" label="收益率" />
      <el-table-column prop="盈利金额" label="盈利金额" />
      <el-table-column prop="手数分值" label="手数分值" />
    </el-table>

    <el-button
      type="danger"
      size="large"
      style="
        background: #ce0203;
        border: #ce0203;
        --el-button-size: 23px;
        font-size: 12px;
        margin-left: 10px;
        margin-top: 20px;
        margin-bottom: 30px;
      "
      >查看详情 »</el-button
    >
  </div>

  <div class="container">
    <div>
      <h1>奖金收入排行榜</h1>
      <span>BONUS RANKNG</span>
      <div class="line"></div>
    </div>

    <el-row :gutter="20">
      <el-col :span="12"
        ><div class="grid-content ep-bg-purple" />
        <div style="margin-bottom: 10px">比赛奖金排行</div>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column prop="排名" label="排名" width="180" />
          <el-table-column prop="昵称" label="昵称" width="180" />
          <el-table-column prop="address" label="参赛次数" /> </el-table
      ></el-col>
      <el-col :span="12"
        ><div class="grid-content ep-bg-purple" />
        <div style="margin-bottom: 10px">邀请奖金排行</div>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column prop="排名" label="排名" width="180" />
          <el-table-column prop="昵称" label="昵称" width="180" />
          <el-table-column prop="address" label="参赛次数" /> </el-table
      ></el-col>
    </el-row>
  </div>

  <div class="container">
    <div>
      <h1>新闻资讯</h1>
      <span>NEW</span>
      <div class="line"></div>
    </div>
    <el-row>
      <el-col :span="9"
        ><div class="grid-content ep-bg-purple" />
        <img style="height: 309px" src="@/assets/17.jpg" alt="Element logo" />
      </el-col>
      <el-col
        :span="15"
        style="
          padding: 20px 30px 0 30px;
          text-align: left;
          background: #0f0f0f;
          line-height: 25px;
          height: 309px;
        "
        ><div class="grid-content ep-bg-purple-light" />

        <div
          style="display: flex; align-items: center; margin-bottom: 10px"
          v-for="(item, index) in 8"
          :key="index"
        >
          <span
            style="
              padding: 0 15px 0 20px;
              width: 90px;
              background: #820807;
              margin-right: 10px;
            "
            >新闻公告</span
          >
          <div>操盘手自由挑战赛获奖感言</div>
          <span>2020/12/14</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref } from "vue";
const tableData = [
  {
    排名: "1",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  },
  {
    排名: "2",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  },
  {
    排名: "3",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  },
  {
    排名: "4",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  },
  {
    排名: "5",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  },
  {
    排名: "6",
    昵称: "Tom",
    MT4账号: "No. 189, Grove St, Los Angeles",
    初始资金: "2016-05-03",
    当前净值: "Tom",
    利润率: "2016-05-03",
    回撤率: "Tom",
    收益率: "2016-05-03",
    盈利金额: "Tom",
    手数分值: "2016-05-03",
  },
];
</script>

<style scoped>
.text-center {
  overflow-y: hidden;
}

.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  display: flex;
  align-items: center;
  margin: 0;
  text-align: center;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 1200px;
  margin: 80px auto 0;
  color: #fff;

  div {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    line-height: 0px;
  }
  span {
    font-size: 16px;
  }
  .line {
    width: 80%;
    height: 1px;
    background: #8d0100;
    margin: 10px auto 30px;
  }
}

/deep/.el-table th.el-table__cell {
  background-color: var(--el-table-header-bg-color);
  background: #910101;
  border-bottom: none;
}
/deep/.el-table tr {
  background-color: var(--el-table-tr-bg-color);
  background: black;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: var(--el-fill-color-lighter);
  background: #1c1c1c;
}
/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

/deep/.el-table--fit .el-table__inner-wrapper:before {
  width: 100%;
  border: none;
  display: none;
}
</style>
